import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../theme/ISpcTheme';

export type LoaderStylesClasses = 'loaderDot' | 'loaderDot1' | 'loaderDot2' | 'loaderDot3';

const loaderStyles = makeStyles<ISpcTheme, LoaderStylesClasses>(({ palette }) => ({
  loaderDot: {
    color: palette.primary.main,
    animationName: '$loader',
    animationDuration: '1.5s',
    animationIterationCount: 'infinite',
    padding: '0 2px 0 2px',
  },
  loaderDot1: {},
  loaderDot2: {
    animationDelay: '0.5s',
  },
  loaderDot3: {
    animationDelay: '1s',
  },
  '@keyframes loader': {
    '0%': {
      opacity: 0.1,
    },
    '50%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0.1,
    },
  },
}));

export default loaderStyles;
